export const EXCHANGE_CODES = {
  NSE: 1,
  NFO: 2,
  CDS: 3,
  MCX: 4,
  MCXSX: 5,
  BSE: 6,
  BFO: 7,
  BCD: 8,
  NSE_INDICES: 9,
  NCDEX: 10,
  NCO: 11,
  NSLBM: 12,
  NOFS: 13,
  DSE: 14,
  BSLBM: 15,
  DCSX: 19,
};

export const SUBSCRIPTION_TYPES = {
  MARKETDATA: 'marketdata',
  SPREAD: 'spread_marketdata',
  SNAPQUOTE: 'snapquote',
};

export const WS_STATES = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3
}; 